import { Box, chakra, Flex, Image, shouldForwardProp } from "@chakra-ui/react";
import { isValidMotionProp, motion } from "framer-motion";
import React from "react";
import { COMMON_WEB_PATH } from "../../constant";
import i18next from "i18next";
import { useTranslation } from "react-i18next";
import CommonModal from "../Common/CommonModal";

const ChakraBox = chakra(motion.div, {
  shouldForwardProp: (prop) =>
    isValidMotionProp(prop) || shouldForwardProp(prop),
});

const WebsiteMaintainWrapper = ({ children }) => {
  const { t } = useTranslation();
  const i18n_common = (key, props) => t(`common.${key}`, { ...props });

  const isMaintain = window.is_under_maintenance;
  return isMaintain ? (
    <CommonModal bgNone>
      <Box fontSize="24px" color="white" textAlign="center" mb={2}>
        {i18n_common("站台維護中")}
      </Box>

      <Flex
        gap={4}
        mb={4}
        justifyContent="space-between"
        alignItems="center"
      ></Flex>
    </CommonModal>
  ) : (
    children
  );
};

export default WebsiteMaintainWrapper;
